import React, { useState } from "react";
import { Tabs, Tab, Typography, Box } from "@mui/material";

// core components
import Navbar from "components/Navbars/Navbar.js";
import SubHeader from "components/Headers/SubHeaderBanner";
import DarkFooter from "components/Footers/DarkFooter.js";
import PanelCountdown from "components/PanelCountdown";
// import events from "./agenda.json";
import agendaSchedule from "./agenda";
import "./style.scss";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          {/* <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box> */}
          <div className="index">{children}</div>
        </>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Agenda() {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });

  // const [basicActive, setBasicActive] = useState('tab1');

  // const handleBasicClick = (value) => {
  //     if (value === basicActive) {
  //         return;
  //     }

  //     setBasicActive(value);
  // };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    event.preventDefault();
  };

  return (
    <>
      <Navbar />
      <SubHeader
        title="CONFERENCE AGENDA"
        image={require("assets/img/Macau-2026/agenda.jpg")}
      />
      <div className="wrapper position-relative mb-5">
        <div className="container main mt-5 px-lg-5">
          <h4>
            The FIBS Global Conference 2026 will be held in Macau. The 3.5-day
            event will consist of keynote speeches, network updates,
            Face-to-Face Meetings, cocktail receptions, and after-conference
            evening events to give all delegates an unforgettable networking
            experience.
          </h4>

          <div className="container" style={{ marginBottom: "200px" }}>
            <div className="col-12 text-left pt-3 d-none d-md-block desktop-table">
              <div className="bg-white shadow px-2 pt-2 pb-3">
                <div className="row">
                  <div className="col-12 text-center">
                    <div className="table-title">
                      <h3 className="title">
                        FIBS Global Conference 03-06 March
                      </h3>
                    </div>
                  </div>
                </div>

                {/* {agendaSchedule.map((day, index) => (
                  <div key={index}>
                    <div className="text-center">
                      <h5>{day.date}</h5>
                    </div>
                    <table className="table table-bordered table-striped light-dark agenda-table">
                      <thead>
                        <tr>
                          <th scope="col">Time</th>
                          <th scope="col">Event</th>
                          <th scope="col">Dress Code / Venue</th>
                        </tr>
                      </thead>
                      <tbody>
                        {day.events.map((event, idx) => (
                          <tr
                            key={idx}
                            className={event.break ? "bg-light text-muted" : ""}
                          >
                            <td>{event.time}</td>
                            <td>
                              {event.title}
                              {event.description.length > 0 && (
                                <>
                                  <br />
                                  {event.description}
                                </>
                              )}
                            </td>
                            <td>{event.venue}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))} */}

                <div className="text-center">
                  <h5>Tuesday, 03 March 2026</h5>
                </div>
                <table className="table table-bordered table-striped light-dark agenda-table">
                  <thead>
                    <tr>
                      <th scope="col">Time</th>
                      <th scope="col">Event</th>
                      <th scope="col">Dress Code / Venue</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>15:00 – 18:00</td>
                      <td>
                        <span className="font-weight-bold">
                          Onsite Registration
                        </span>
                        <br />
                        <span className="font-italic">
                          Pick up conference badge and materials near hotel
                          lobby
                        </span>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>15:00 – 18:00</td>
                      <td>
                        <span className="font-weight-bold">
                          The FIBS Playoff
                        </span>{" "}
                        <br />
                        <span className="font-italic">
                          Kick off the excitment with a friendly
                          tournament-style showdown where delegates can compete,
                          cheer, and connect before the evening’s welcome
                          cocktail.
                        </span>
                        <br />
                      </td>
                      {/* <td></td> */}
                      <td> Smart Casual | Venue to be advised</td>
                    </tr>
                    <tr>
                      <td>19:00 – 21:30 </td>
                      <td className="font-weight-bold">
                        FIBS Welcome Cheers @ Joyride
                      </td>
                      {/* <td></td> */}
                      <td>
                        Smart Casual | Venue: Joyride Diner - Studio City Macau,
                        Level 1
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="text-center mt-5">
                  <h5>Wednesday, 04 March 2026</h5>
                </div>
                <table className="table table-bordered table-striped light-dark agenda-table">
                  <thead>
                    <tr>
                      <th scope="col">Time</th>
                      <th scope="col">Event</th>
                      {/* <th scope="col">Venue</th> */}
                      <th scope="col">Dress Code / Venue</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>09:00 – 09:15 </td>
                      <td className="font-weight-bold">
                        Opening Remarks by Fredrik Nyberg
                      </td>
                      {/* <td>Conference Hall</td> */}
                      <td>Smart Casual | Venue: Ballroom</td>
                    </tr>
                    <tr>
                      <td>09:15 – 10:00 </td>
                      <td>
                        <span className="font-weight-bold">
                          Speech / Panel Discussion{" "}
                        </span>
                        <span className="font-italic"></span>
                      </td>
                      <td>Smart Casual | Venue: Ballroom</td>
                    </tr>
                    <tr>
                      <td>10:00 – 10:15 </td>
                      <td className="font-weight-bold">Coffee Break</td>
                      {/* <td></td> */}
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>10:15 – 11:00 </td>
                      <td>
                        <span className="font-weight-bold">
                          Speech / Panel Discussion
                        </span>
                      </td>
                      <td>Smart Casual | Venue: Ballroom</td>
                    </tr>
                    <tr>
                      <td>11:00 – 11:45 </td>
                      <td className="font-weight-bold">Group Photo</td>
                      {/* <td></td> */}
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>11:45 – 13:20 </td>
                      <td className="font-weight-bold">Lunch</td>
                      {/* <td>Mina’s Kitchen</td> */}
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>13:20 – 17:00 </td>
                      <td className="font-weight-bold">
                        Face-to-Face Meetings
                      </td>
                      {/* <td></td> */}
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>18:15</td>
                      <td>Meet at hotel lobby for transport to dinner</td>
                      <td>Smart Casual | Venue: Hotel lobby</td>
                    </tr>
                    <tr>
                      <td>19:00 - 22:00</td>
                      <td>
                        <span className="font-weight-bold">
                          FIBS Taste of Portugal at Coloane Inn
                        </span>
                        <br />
                        <span className="font-italic">
                          Experience the authentic flavors of Portugal in the
                          tranquil heart of Coloane. Join us for an evening of
                          rich heritage, warm hospitality, and a memorable
                          culinary journey at Coloane Inn
                        </span>
                      </td>
                      <td>Smart Casual | Venue: Coloane Inn, Macau</td>
                    </tr>
                    {/* <tr>
                      <td>22:00</td>
                      <td className="font-weight-bold">-</td>
                      <td>-</td>
                    </tr> */}
                  </tbody>
                </table>
                <div className="text-center mt-5">
                  <h5>Thursday, 05 March 2026</h5>
                </div>
                <table className="table table-bordered table-striped light-dark agenda-table">
                  <thead>
                    <tr>
                      <th scope="col">Time</th>
                      <th scope="col">Event</th>
                      {/* <th scope="col">Venue</th> */}
                      <th scope="col">Dress Code / Venue</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>10:00 – 10:45 </td>
                      <td>
                        <span className="font-weight-bold">
                          Panel discussion{" "}
                        </span>{" "}
                      </td>
                      <td> Smart Casual | Venue: Ballroom</td>
                    </tr>
                    <tr>
                      <td>10:45-11:00</td>
                      <td>
                        <span className="font-weight-bold">Coffee Break</span>{" "}
                      </td>
                      <td> Smart Casual | Venue: Ballroom</td>
                    </tr>
                    <tr>
                      <td>11:00 – 12:45</td>
                      <td>
                        <span className="font-weight-bold">
                          Face-to-Face Meetings{" "}
                        </span>{" "}
                      </td>
                      <td>Smart Casual | Venue: Ballroom</td>
                    </tr>
                    <tr>
                      <td>12:40 - 14:00</td>
                      <td className="font-weight-bold">Lunch</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>14:00 – 18:00 </td>
                      <td>
                        <span className="font-weight-bold">
                          FIBS Macau City Explorer with Grand Prix Museum
                        </span>{" "}
                        <br />
                        <span className="font-italic">
                          Uncover Macau’s unique blend of tradition and
                          modernity, topped off with a fascinating tour of the
                          iconic Macau Grand Prix Museum.
                        </span>
                      </td>
                      <td>FIBS polo t-shirt | Venue: meet at hotel lobby</td>
                    </tr>
                    <tr>
                      <td>18:00 onwards</td>
                      <td>Free & Easy</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>22:00 - 00:00 </td>
                      <td>
                        <span className="font-weight-bold">
                          The FIBS Eclipse @ MOP
                        </span>
                        <br />
                        <span className="font-italic">
                          Join us for an unforgettable night of music, dancing,
                          and celebration at Moon on Planet.
                        </span>
                      </td>
                      <td>
                        {" "}
                        Smart Casual / Club Chic | Venue: meet at hotel lobby
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="text-center mt-5">
                  <h5>Friday, 06 March 2026</h5>
                </div>
                <table className="table table-bordered table-striped light-dark agenda-table">
                  <thead>
                    <tr>
                      <th scope="col">Time</th>
                      <th scope="col">Event</th>
                      <th scope="col">Dress Code / Venue</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>10:00 – 12:40 </td>
                      <td className="font-weight-bold">
                        Face-to-Face Meetings
                      </td>
                      <td>Smart Casual | Venue: Ballroom</td>
                    </tr>
                    <tr>
                      <td>12:40 – 14:00 </td>
                      <td className="font-weight-bold">Lunch</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>14:00 – 15:20 </td>
                      <td className="font-weight-bold">
                        Face-to-Face Meetings
                      </td>
                      <td>Smart Casual | Venue: Ballroom</td>
                    </tr>
                    <tr>
                      <td>15:20 - onwards</td>
                      <td>
                        <span className="font-weight-bold">
                          The Finale – Chill & Cheers
                        </span>{" "}
                        <br />
                        <span className="font-italic">
                          Wrap up the conference with a relaxed hour of drinks
                          and good company until we meet again.
                        </span>
                      </td>
                      <td>Venue : Ballroom</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="container container-padding d-md-none p-0">
              <div class="col-12 force-text-black px-1 pb-2">
                <div class="card">
                  <div class="card-body px-2 py-3">
                    {/* {
                                            events.map((event) => (
                                                <>
                                                    
                                                    <table width="100%">
                                                        <tbody>
                                                            <tr>
                                                                <td valign="top" width="30%">Time</td>
                                                                <td valign="top">{event.from} - {event.to}</td>
                                                            </tr>
                                                            <tr>
                                                                <td valign="top">Event</td>
                                                                <td valign="top"><div dangerouslySetInnerHTML={{ __html: event.event }}></div></td>
                                                            </tr>
                                                            <tr>
                                                                <td valign="top">Venue</td>
                                                                <td valign="top">{event.vanue}</td>
                                                            </tr>
                                                            <tr>
                                                                <td valign="top">Dress Code / Venue</td>
                                                                <td valign="top">{event.dress}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </>
                                            ))
                                        } */}
                    <div className="table-title">
                      <h3 className="title text-center">
                        FIBS Global Conference 03-06 March
                      </h3>
                    </div>
                    <div className="text-center">
                      <h5>Tuesday, 03 March 2026</h5>
                    </div>
                    <table width="100%">
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            15:00 onwards
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <strong>Onsite Registration</strong>
                            <br />
                            <span className="font-italic">
                              Pick up conference badge and materials near hotel
                              lobby
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">-</td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            15:00 – 18:00
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <span className="font-weight-bold">
                              The FIBS Playoff
                            </span>{" "}
                            <br />
                            <span className="font-italic">
                              Kick off the excitment with a friendly
                              tournament-style showdown where delegates can
                              compete, cheer, and connect before the evening’s
                              welcome cocktail.
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">
                            Smart Casual | Venue to be advised
                          </td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            19:00 – 21:30
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <strong>FIBS Welcome Cheers @ Joyride</strong>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">
                            Smart Casual | Venue: Joyride Diner - Studio City
                            Macau, Level 1
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="text-center mt-5">
                      <h5>Wednesday, 04 March 2026</h5>
                    </div>
                    <table width="100%">
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            09:00 – 09:15
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <strong>Opening Remarks by Fredrik Nyberg</strong>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">Smart Casual | Venue: Ballroom</td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            09:15 – 10:00
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <span className="font-weight-bold">
                              Speech / Panel Discussion{" "}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">-</td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            10:00 – 10:15
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <span className="font-weight-bold">
                              Coffee Break{" "}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">-</td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            10:15 – 11:00
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <span className="font-weight-bold">
                              Speech / Panel Discussion{" "}
                            </span>{" "}
                          </td>
                        </tr>
                        {/* <tr>
                                                    <td valign="top">Venue</td>
                                                    <td valign="top">--</td>
                                                </tr>*/}
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">Smart Casual | Venue: Ballroom</td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            11:00 – 11:45
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td
                            valign="top"
                            className="border-bottom font-weight-bold"
                          >
                            Group Photo
                          </td>
                        </tr>
                        {/* <tr>
                                                    <td valign="top">Venue</td>
                                                    <td valign="top">--</td>
                                                </tr>*/}
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">-</td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            11:45 – 13:20
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td
                            valign="top"
                            className="border-bottom font-weight-bold"
                          >
                            Lunch
                          </td>
                        </tr>
                        {/* <tr>
                                                    <td valign="top">Venue</td>
                                                    <td valign="top">Mina’s Kitchen</td>
                                                </tr> */}
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">-</td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            13:20 – 17:00
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td
                            valign="top"
                            className="border-bottom font-weight-bold"
                          >
                            Face-to-Face Meetings
                          </td>
                        </tr>
                        {/* <tr>
                                                    <td valign="top">Venue</td>
                                                    <td valign="top"></td>
                                                </tr> */}
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">-</td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            18:15
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td
                            valign="top"
                            className="border-bottom font-weight-bold"
                          >
                            Meet at hotel lobby for transport to dinner
                          </td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            19:00 - 22:00
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom ">
                            <span className="font-weight-bold">
                              FIBS Taste of Portugal at Coloane Inn
                            </span>
                            <br />
                            <span className="font-italic">
                              Experience the authentic flavors of Portugal in
                              the tranquil heart of Coloane. Join us for an
                              evening of rich heritage, warm hospitality, and a
                              memorable culinary journey at Coloane Inn
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td>Smart Casual | Venue: Coloane Inn, Macau</td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="text-center mt-5">
                      <h5>Thursday, 05 March 2026</h5>
                    </div>
                    <table width="100%">
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            10:00 – 10:45
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <span className="font-weight-bold">
                              Panel discussion
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">Smart Casual | Venue: Ballroom</td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            10:45-11:00
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <span className="font-weight-bold">
                              Coffee Break
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">Smart Casual | Venue: Ballroom</td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            11:00 – 12:45
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <span className="font-weight-bold">
                              Face-to-Face Meetings
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">Smart Casual | Venue: Ballroom</td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            12:40 – 14:00
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td
                            valign="top"
                            className="border-bottom font-weight-bold"
                          >
                            Lunch
                          </td>
                        </tr>
                        {/* <tr>
                                                    <td valign="top">Venue</td>
                                                    <td valign="top">Mina’s Kitchen</td>
                                                </tr> */}
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            14:00 – 18:00
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom ">
                            <span className="font-weight-bold">
                              {" "}
                              FIBS Macau City Explorer with Grand Prix Museum
                            </span>
                            <br />
                            <span className="font-italic">
                              Uncover Macau’s unique blend of tradition and
                              modernity, topped off with a fascinating tour of
                              the iconic Macau Grand Prix Museum.
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">
                            FIBS polo t-shirt | Venue: meet at hotel lobby
                          </td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            18:00 onwards
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            Free & Easy
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top" className="border-bottom">
                            -
                          </td>
                        </tr>
                      </tbody>

                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            22:00 - 00:00
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <span className="font-weight-bold">
                              The FIBS Eclipse @ MOP
                            </span>
                            <br />
                            <span className="font-italic">
                              Join us for an unforgettable night of music,
                              dancing, and celebration at Moon on Planet.
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top" className="border-bottom">
                            Smart Casual / Club Chic | Venue: meet at hotel
                            lobby
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="text-center mt-5">
                      <h5>Friday, 06 March 2026</h5>
                    </div>
                    <table width="100%">
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            10:00 – 12:40
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td
                            valign="top"
                            className="border-bottom font-weight-bold"
                          >
                            Face-to-Face Meetings
                          </td>
                        </tr>
                        {/*   <tr>
                                                    <td valign="top">Venue</td>
                                                    <td valign="top">Conference Hall</td>
                                                </tr>*/}
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">Smart Casual | Venue: Ballroom</td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            12:40 – 14:00
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <strong>Lunch</strong>
                          </td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            14:00 – 15:20
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <strong>Face-to-Face Meetings</strong>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">Smart Casual | Venue: Ballroom</td>
                        </tr>
                      </tbody>
                      <tbody className="border-top">
                        <tr>
                          <td valign="top" width="30%">
                            Time
                          </td>
                          <td valign="top" className="border-bottom">
                            15:20 onwards
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Event</td>
                          <td valign="top" className="border-bottom">
                            <strong> The Finale – Chill & Cheers</strong>
                            <br />
                            <span className="font-italic">
                              Wrap up the conference with a relaxed hour of
                              drinks and good company until we meet again.
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td valign="top">Dress Code / Venue</td>
                          <td valign="top">Venue : Ballroom</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                <Tab label="Day 1" {...a11yProps(0)} />
                                <Tab label="Day 2" {...a11yProps(1)} />
                                <Tab label="Day 3" {...a11yProps(2)} />
                            </Tabs>
                        </Box>
                        <TabPanel value={value} index={0}>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                            <div className='row schedule-item'>
                                <div className="col-md-2"><h4>11:35 AM</h4></div>
                                <div className="col-md-6">
                                    <h4>111</h4>
                                </div>
                                <div className="speaker-logo col-md-4">
                                    <h4>Lunch Break</h4>
                                </div>
                            </div>
                        </TabPanel>
                    </Box> */}
        </div>
        <PanelCountdown date="03/03/2026" />
        {/* <DarkFooter /> */}
      </div>
    </>
  );
}

export default Agenda;
